import { Bell, TrendingUp, Zap, Settings2, Clock, Smartphone } from "lucide-react";

const features = [
  {
    icon: TrendingUp,
    title: "Volume spike detection",
    description: "We scan thousands of tickers and flag when volume jumps 200%+ above the 30-day average.",
    stat: "2,847 spikes caught today",
  },
  {
    icon: Bell,
    title: "Instant SMS & email alerts",
    description: "The moment something moves, you know. No refreshing, no missed windows.",
    stat: "< 8 sec avg delivery",
  },
  {
    icon: Settings2,
    title: "Your rules, your alerts",
    description: "Set custom thresholds for volume, price range, and float size. Only get pinged when it matters.",
    stat: "100% customizable",
  },
  {
    icon: Zap,
    title: "Low-float focus",
    description: "Filter for stocks under 50M float where volume spikes actually move prices.",
    stat: "Sub-50M float filter",
  },
  {
    icon: Clock,
    title: "Pre-market & after-hours",
    description: "Monitor extended sessions when institutions make moves before retail catches on.",
    stat: "4 AM – 8 PM ET coverage",
  },
  {
    icon: Smartphone,
    title: "Works anywhere",
    description: "Get alerts on your phone, watch, or desktop. Act fast from wherever you are.",
    stat: "iOS, Android, web",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-20 md:py-28 px-6">
      <div className="container mx-auto">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-semibold text-accent uppercase tracking-wide mb-3">
            Features
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-balance">
            Built for traders who actually trade
          </h2>
          <p className="text-lg text-muted-foreground">
            Not another bloated platform. Just the signals you need, when you need them.
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-card rounded-xl p-6 border border-border hover:border-accent/30 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-accent/15 transition-colors">
                <feature.icon className="h-5 w-5 text-accent" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-[15px] leading-relaxed mb-4">{feature.description}</p>
              <p className="text-xs font-medium text-accent">{feature.stat}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
